// client/src/components/fornecedores/FornecedorRow.js
import React from 'react';
import { MoreVertical, UserCircle, Building as BuildingIcon } from 'lucide-react';

const FornecedorRow = ({
  fornecedor,
  displayId,
  onOpenActions,
  loading
}) => {
  const {
    nomeFantasia,
    razaoSocial,
    telefonePrincipal,
    emailPrincipal,
    tipoPessoa,
    documentoPrincipal,
    ativo
  } = fornecedor || {};

  const nomePrincipalExibicao = nomeFantasia || razaoSocial;

  const documentoFormatado = documentoPrincipal ?
    (tipoPessoa === 'Física'
      ? documentoPrincipal.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4")
      : documentoPrincipal.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5"))
    : 'N/D';

  const telefoneFormatado = telefonePrincipal
    ? String(telefonePrincipal).replace(/(\d{2})(\d{4,5})(\d{4})/, "($1) $2-$3")
    : '-';

  return (
    <tr className={`table-row-hover ${!ativo ? 'opacity-60' : ''}`}>
      <td className="td-id">{displayId}</td>
      <td className="td-status">
        <span className={`badge ${ativo ? 'badge-green' : 'badge-red'}`}>
          {ativo ? 'Ativo' : 'Inativo'}
        </span>
      </td>
      <td className="td-name">
        {tipoPessoa === 'Física'
          ? <UserCircle size={15} className="inline mr-1.5 text-gray-500" />
          : <BuildingIcon size={15} className="inline mr-1.5 text-gray-500" />
        }
        {nomePrincipalExibicao}
      </td>
      <td>{documentoFormatado}</td>
      <td className="td-email">
        <a href={`mailto:${emailPrincipal}`} className="text-primary hover:underline">
          {emailPrincipal}
        </a>
      </td>
      <td>{telefoneFormatado}</td>
      <td className="text-right">
        <button
          onClick={() => onOpenActions(fornecedor)}
          title="Ações"
          className="action-button-icon text-gray-600 hover:text-gray-900 disabled:opacity-50 disabled:cursor-not-allowed"
          disabled={loading}
        >
          <MoreVertical size={18} />
        </button>
      </td>
    </tr>
  );
};

export default FornecedorRow;